var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2227_1099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.422 1.563h-1.797V.625a.625.625 0 1 0-1.25 0v.938h-8.75V.625a.625.625 0 1 0-1.25 0v.938H2.578A2.581 2.581 0 0 0 0 4.14v13.28A2.581 2.581 0 0 0 2.578 20h14.844A2.581 2.581 0 0 0 20 17.422V4.14a2.581 2.581 0 0 0-2.578-2.579zM2.578 2.813h1.797v.624a.625.625 0 1 0 1.25 0v-.624h8.75v.624a.625.625 0 1 0 1.25 0v-.624h1.797A1.33 1.33 0 0 1 18.75 4.14v1.484H1.25V4.141a1.33 1.33 0 0 1 1.328-1.329zM17.422 18.75H2.578a1.33 1.33 0 0 1-1.328-1.328V6.875h17.5v10.547a1.33 1.33 0 0 1-1.328 1.328z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 13.333h-2.857v2.857h-.953v-2.857H6.667v-.952h2.857V9.524h.953v2.857h2.857v.952z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2227_1099"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCalendar;